import React from "react";
import { useState } from "react";
import logo from "..//assets/logo.png";
import { CiUser } from "react-icons/ci";
import icon from "..//assets/icon.png";
import icon1 from "..//assets/icon1.png";
import icon2 from "..//assets/icon2.png";
import icon3 from "..//assets/icon3.png";
import face from "..//assets/face.png";
import twit from "..//assets/twit.png";
import insta from "..//assets/insta.png";
import { HiMenu, HiX } from "react-icons/hi";
import product from "..//assets/product1.png";
import product1 from "..//assets/product2.png";
import product2 from "..//assets/product3.png";
import product3 from "..//assets/product4.png";
import product4 from "..//assets/product5.png";
import product5 from "..//assets/product6.png";
import product6 from "..//assets/product7.png";
import product7 from "..//assets/product8.png";
import ProductImageGallery from "./ProductImageGallery";
import ProductInfo from "./ProductInfo";
import RecommendedProducts from "./RecommendedProducts";

import { useParams } from "react-router-dom";

function ProductDetails1() {
    // import bannerImage from './assets/banner.jpg';  // Logo image path
    // import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

    return (
        <>
            <Header />
            <ProductDetail />
            <FAQSection />
            <Footer />
            {/* <AnimatedBoxes />  */}
        </>
    );
}

function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <header className="bg-white shadow-md">
            <div className="flex items-center justify-between px-4 py-4 lg:mx-20">
                {/* Logo Section */}
                <div className="flex items-center">
                    <img src={logo} alt="Bestie" className="h-16" />
                </div>

                {/* Desktop Menu Section */}
                <nav className="hidden space-x-8 font-sans font-semibold text-1xl lg:flex">
                    <a href="/" className="text-gray-700 hover:text-gray-900">
                        HOME
                    </a>
                    <a
                        href="/products"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        PRODUCTS
                    </a>
                    <a
                        href="/blog"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        BLOG
                    </a>
                    <a
                        href="/contact"
                        className="text-gray-700 hover:text-gray-900"
                    >
                        CONTACT
                    </a>
                </nav>

                {/* Search Bar and Admin Section */}
                <div className="flex items-center space-x-6">
                    {/* Search Bar */}
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Search"
                            className="px-4 py-2 text-sm border border-gray-300 rounded-full outline-none max-sm:hidden max-md:hidden focus:ring-2 focus:ring-gray-500"
                        />
                        <button className="absolute right-2 top-2">
                            <svg
                                className="w-5 h-5 text-gray-500 max-sm:hidden max-md:hidden"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1110.5 3a7.5 7.5 0 016.15 12.65z"
                                />
                            </svg>
                        </button>
                    </div>

                    {/* Admin Icon */}
                    <button>
                        <CiUser />
                    </button>

                    {/* Mobile Menu Toggle Button */}
                    <button onClick={toggleMenu} className="lg:hidden">
                        {/* Switch between menu icon and close icon */}
                        {isMenuOpen ? (
                            <HiX className="w-6 h-6 text-gray-700" /> // Close icon when menu is open
                        ) : (
                            <HiMenu className="w-6 h-6 text-gray-700" /> // Menu icon when menu is closed
                        )}
                    </button>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <div className="absolute top-0 left-0 z-20 w-2/3 h-full p-6 bg-white shadow-lg lg:hidden">
                    <button
                        onClick={toggleMenu}
                        className="mb-8 text-gray-700 hover:text-gray-900"
                    >
                        <HiX className="w-8 h-8" />{" "}
                        {/* Close icon in the mobile menu */}
                    </button>
                    <nav className="flex flex-col space-y-4 font-sans font-semibold">
                        <a
                            href="/"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            HOME
                        </a>
                        <a
                            href="/products"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            PRODUCTS
                        </a>
                        <a
                            href="/blog"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            BLOG
                        </a>
                        <a
                            href="/contact"
                            className="text-gray-700 hover:text-gray-900"
                        >
                            CONTACT
                        </a>
                    </nav>
                </div>
            )}
            <div className="border"></div>
        </header>
    );
}
function ProductDetail() {
    const mainProduct = {
        id: 1,
        name: "Product 2Microfabric Fabric Round Neck Full Sleeve T-Shirt with Brea... ",
        //   color: "Blue",
        price: "₹799.00",
        imageSrc: product1,
        imageAlt: "Product 2 description",
        imageSrc: product, // Use the imported image variable
        thumbnails: [
            product1, // Replace with the actual imported variables
            product2,
            product3,
            product4,
        ],
    };

    const recommendedProducts = [
        {
            id: 2,
            name: "Microfabric Fabric Round Neck Full Sleeve T-Shirt",
            price: "₹799.00",
            imageSrc: product1, // Use the imported image variable
        },
        {
            id: 3,
            name: "Microfabric Fabric Round Neck Half Sleeve T-Shirt",
            price: "₹799.00",
            imageSrc: product2, // Use the imported image variable
        },
        {
            id: 4,
            name: "Microfabric Fabric Round Neck Full Sleeve T-Shirt",
            price: "₹599.00",
            imageSrc: product3, // Use the imported image variable
        },
        {
            id: 5,
            name: "Microfabric Fabric Round Neck Half Sleeve T-Shirt with Brea... ",

            price: "₹799.00",
            imageSrc: product4,
            imageAlt: "Product 5 description",
            // href: "/product/2"
        },
    ];

    return (
        <div className="mt-10 bg-white">
            <div className="px-4 py-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
                {/* Breadcrumb */}
                <div className="flex items-center space-x-2 text-sm text-gray-500">
                    <a
                        href="/"
                        className="font-sans text-lg font-medium hover:text-gray-700"
                    >
                        Home
                    </a>
                    <span className="text-gray-400">›</span>
                    <a
                        href="/products"
                        className="font-sans text-lg font-medium hover:text-black"
                    >
                        Products
                    </a>
                    <span className="text-gray-400">›</span>
                    <span className="font-sans text-lg font-medium hover:text-black">
                        Bestie - Adult Diapers
                    </span>
                </div>

                {/* Main Product Section */}
                <div className="flex flex-col mt-6 lg:flex-row">
                    <ProductImageGallery product={mainProduct} />
                    <ProductInfo product={mainProduct} />
                </div>

                {/* Recommended Products Section */}
                <RecommendedProducts products={recommendedProducts} />
            </div>
        </div>
    );
}

function FAQSection() {
    const [activeIndex, setActiveIndex] = useState(null);

    const faqs = [
        {
            question: "What Is Your Return Policy?",
            answer: "You can return items within 30 days of purchase.",
        },
        {
            question: "How Long Does Shipping Take?",
            answer: "Shipping typically takes 5-7 business days.",
        },
        {
            question: "Do You Offer International Shipping?",
            answer: "Yes, we ship to select countries worldwide.",
        },
        {
            question: "Can I Change My Order After Placing It?",
            answer: "You can change your order within one hour of placing it.",
        },
    ];
    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="w-full py-16 bg-gray-50">
            {" "}
            {/* Full section wrapper with padding */}
            <div className="max-w-4xl px-4 mx-auto sm:px-6 lg:px-8">
                {" "}
                {/* Container for equal left-right space */}
                <h2 className="font-sans text-3xl font-semibold tracking-tight text-center text-gray-900">
                    Frequently Asked Questions
                </h2>
                <br></br>
                {/* FAQ List */}
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div
                            key={index}
                            className="pb-4 border-b-2 border-gray-200 cursor-pointer"
                            onClick={() => toggleFAQ(index)}
                        >
                            <div className="flex items-center justify-between">
                                <h3 className="font-sans text-lg font-semibold text-gray-700">
                                    {faq.question}
                                </h3>
                                <svg
                                    className={`w-6 h-6 transition-transform transform ${
                                        activeIndex === index
                                            ? "rotate-180"
                                            : ""
                                    }`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>
                            </div>
                            {activeIndex === index && (
                                <p className="mt-2 text-gray-600">
                                    {faq.answer}
                                </p>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

function Footer() {
    return (
        <div className=" footer w-full py-7 bg-[#FFB4703D]">
            {/* Logo Row */}
            <div className="flex items-center justify-center">
                <img src={logo} alt="Logo" className="w-32" />
            </div>

            {/* Columns Row */}
            <div className="grid grid-cols-1 gap-4 mt-6 md:grid-cols-4">
                {/* Column 1 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon}
                        alt="Free Shipping"
                        className="flex flex-row h-12 w-15"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">Free Shipping</h3>
                    <p className="font-sans font-normal ">
                        On all orders over ₹50
                    </p>
                </div>

                {/* Column 2 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon1}
                        alt="Secure Payment"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">Secure Payment</h3>
                    <p className="font-sans font-normal ">
                        Guaranteed safe checkout
                    </p>
                </div>

                {/* Column 3 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon2}
                        alt="Customer Support"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">
                        24/7 Customer Support
                    </h3>
                    <p className="font-sans font-normal ">
                        We're here to help you
                    </p>
                </div>

                {/* Column 4 */}
                <div className="flex flex-col items-center">
                    <img
                        src={icon3}
                        alt="Return Policy"
                        className="w-12 h-12"
                    />
                    <br></br>
                    <h3 className="font-sans font-bold">Easy Returns</h3>
                    <p className="font-sans font-normal ">
                        Hassle-free returns within 30 days
                    </p>
                </div>
            </div>

            {/* Social Media Row */}
            <div className="mt-6 text-center">
                <h3 className="font-sans font-bold">Follow Us</h3>
                <div className="flex justify-center mt-2 space-x-4">
                    <a
                        href="https://facebook.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={face} alt="Facebook" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://twitter.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={twit} alt="Twitter" className="w-8 h-8" />
                    </a>
                    <a
                        href="https://instagram.com"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img src={insta} alt="Instagram" className="w-8 h-8" />
                    </a>
                </div>
            </div>

            {/* Copyright Row */}
            <div className="w-full mx-0 bg-[#52B3A4] py-4 mt-6 text-center text-white font-sans">
                <p>
                    &copy; {new Date().getFullYear()} Bestie care. All rights
                    reserved.
                </p>
            </div>
        </div>
    );
}

export default ProductDetails1;
